import styled from 'styled-components';
import { theme } from '@dls/web';

type ColorContainerProps = {
  type?: string;
  padding?: string;
};

export const TextLinkWrapper = styled.div`
  ${p => `
    padding: ${p.theme.spacing(3)} 0 0;
  `};
  text-align: center;
`;
export const IconWrapper = styled.div`
  ${p => `
    margin-right: ${p.theme.spacing(2)};
    margin-top: 4px
  `};
`;

export const ColorContainer = styled.div<ColorContainerProps>`
  ${p => `
    padding: ${p.theme.spacing(3)};
    margin: ${p.theme.spacing(5)} 0;
  `};
  border-radius: 12px;
  display: flex;

  ${({ type }: ColorContainerProps) => {
    if (type === 'primary') {
      return `background-color: ${theme.main.colours.primary.l3};`;
    } else if (type === 'secondary') {
      return `background-color: #EFEDFD;`;
    } else if (type === 'tertiary') {
      return `background-color: ${theme.main.colours.tertiary.l6};`;
    } else {
      return ``;
    }
  }}

  ${({ padding }: ColorContainerProps) => `
    padding: ${padding};
  `}
`;
